<template>
    <div
        class="flex items-center justify-center text-medium uppercase"
        :class="[textClass, bgClass, mini ? 'text-xxxs w-5 h-5 rounded-0.625' : 'text-xs min-w-6 min-h-6 max-w-6 max-h-6 rounded-1.25']"
    >
        {{ defaultName }}
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    name: {
        type: String,
        default: '',
    },
    bgClass: {
        type: String,
        default: 'bg-purple-50 dark:bg-primary-gradient',
    },
    textClass: {
        type: String,
        default: 'text-gray-370 dark:text-white',
    },
    mini: {
        type: Boolean,
        default: false,
    },
})

const defaultName = computed(() => {
    const arrayString = props.name.split(' ')
    const [first, second] = arrayString

    return props.name ? `${first[0]}${second ? second[0] : ''}` : ' '
})
</script>
